var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33349 1.33283C2.757 0.756343 1.82233 0.756343 1.24584 1.33283C0.669355 1.90932 0.669354 2.84399 1.24584 3.42048L5.91251 7.9995L1.24585 12.5785C0.669364 13.155 0.669364 14.0897 1.24585 14.6662C1.82234 15.2427 2.75701 15.2427 3.3335 14.6662L8.00016 10.0871L12.5792 14.6662C13.1557 15.2427 14.0903 15.2427 14.6668 14.6662C15.2433 14.0897 15.2433 13.155 14.6668 12.5785L10.0878 7.9995L14.6668 3.42041C15.2433 2.84392 15.2433 1.90925 14.6668 1.33276C14.0903 0.756269 13.1557 0.756269 12.5792 1.33276L8.00016 5.91185L3.33349 1.33283Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.73875a6ad46518a6a7b05171bf09d993.svg";
export { ForwardRef as ReactComponent };